import { useState } from 'react';
import { useModalState } from '../../../../../../../hooks/useModalState';
import {
  BusinessPolicyViolationSection,
  BusinessPolicyViolationView,
} from '../businessPolicyViolation.types';

export const useBusinessPolicyViolationsModal = () => {
  const { isOpen, openModal, closeModal } = useModalState();
  const [sections, setSections] = useState<BusinessPolicyViolationSection[]>([]);

  const openSections = (nextSections: BusinessPolicyViolationSection[]) => {
    setSections(nextSections);
    openModal();
  };

  const openViolations = (violations: BusinessPolicyViolationView[]) =>
    openSections([{ violations }]);

  return { isOpen, sections, openViolations, openSections, closeModal };
};
